import { Link } from 'react-router-dom';

import { creditParameters } from '@/shared/api/resources';
import { useAuth } from '@/shared/auth/useAuth';
import { Alert } from '@/shared/ui/Alert';
import { PageHeader } from '@/shared/ui/PageHeader';

import {
  EditorDeParametros,
  ROTA_DO_CONSUMO,
  ROTA_DO_SIMULADOR,
} from './EditorDeParametros';
import type { EscopoDoEditor } from './escopo';

/**
 * Configuracoes > Analise de credito.
 *
 * Os parametros do motor de credito da empresa: a versao ativa, o rascunho, o
 * historico, a comparacao e a heranca do padrao global. Quem nao tem
 * `credito.parametro.update` le e nao edita; quem nao tem `credito.parametro.approve`
 * nao ve o botao de ativar. O servidor confere tudo de novo.
 */
export function CreditSettingsPage() {
  const { can } = useAuth();

  const escopo: EscopoDoEditor = {
    tipo: 'empresa',
    api: creditParameters,
    chave: 'credito-parametros',
    podeEditar: can('credito.parametro.update'),
    podeAtivar: can('credito.parametro.approve'),
  };

  return (
    <div className="flex flex-col gap-5">
      <PageHeader
        title="Analise de credito"
        description="Parametros do motor de credito da empresa, com versao, historico, vigencia e responsavel."
        actions={
          <div className="flex flex-wrap gap-3 text-sm font-medium">
            <Link to="/configuracoes" className="text-brand-600 hover:underline">
              Voltar para Configuracoes
            </Link>
            <Link to={ROTA_DO_CONSUMO} className="text-brand-600 hover:underline">
              Consumo de consultas
            </Link>
            <Link to={ROTA_DO_SIMULADOR} className="text-brand-600 hover:underline">
              Simulador
            </Link>
          </div>
        }
      />
      {can('credito.parametro.view') ? (
        <EditorDeParametros escopo={escopo} />
      ) : (
        <Alert tone="info" title="Sem acesso aos parametros de credito">
          O seu perfil nao inclui a leitura dos parametros do motor de credito.
        </Alert>
      )}
    </div>
  );
}
